import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as AuthAPI from './authAPI';

export const register = createAsyncThunk('auth/register', async ({ username, password}, { rejectWithValue }) => {
    try {
        const response = await AuthAPI.register({ username, password });
        return response.data;
        // return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const login = createAsyncThunk('auth/login', async ({ username, password }, { rejectWithValue }) => {
    try {
        const response = await AuthAPI.login({ username, password });
        return response.data;
        // return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const initialState = {
    register: {
        username: '',
        password: '',
        passwordConfirm: '',
    },
    login: {
        username: '',
        password: '',
    },
    auth: null,
    authError: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        changeField: (state, { payload: { form, key, value }}) => {
            state[form][key] = value;
        },
        initializeForm: (state, { payload: { form }}) => {
            state[form] = initialState[form];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(register.fulfilled, (state, { payload }) => {
                state.auth = payload;
                state.authError = null;
            })
            .addCase(register.rejected, (state, { payload }) => {
                state.auth = null;
                state.authError = payload;
            })
            .addCase(login.fulfilled, (state, { payload }) => {
                state.auth = payload;
                state.authError = null;
            })
            .addCase(login.rejected, (state, { payload }) => {
                state.auth = null;
                state.authError = payload;
            });
    },
});

export const { changeField, initializeForm } = authSlice.actions;
export default authSlice.reducer;